export default {"src":"/_next/static/media/our_values_mask_02.381e2a2c.svg","height":195,"width":375,"blurWidth":0,"blurHeight":0};